import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LoadMoreProps {
  hasNext: boolean;
  loading?: boolean;
  onClick: () => void;
}

export function LoadMore({ hasNext, loading, onClick }: LoadMoreProps): JSX.Element | null {
  if (!hasNext) return null;
  return (
    <div className="flex justify-center border-t p-3">
      <Button variant="outline" size="sm" disabled={loading} onClick={onClick} className="gap-2">
        {loading ? <Loader2 className="h-3 w-3 animate-spin" /> : null}
        Charger plus
      </Button>
    </div>
  );
}
